import { httpRequest } from '@calendly/http-tools'
import {
  resolveSegmentAmplitudeIdentity,
  resolveSegmentAnonymousId,
} from '@calendly/session-replay'

import Settings from 'core/settings'
import CookieService from 'services/cookie'

export const eventService = {
  /**
   * Note: Prefer using the `useTrack` hook for event tracking instead of calling `eventService.dispatch` directly.
   * This method remains available for advanced use cases.
   */
  dispatch: async ({
    name,
    version,
    dependencies,
    entities,
    properties,
    // Retained for API compatibility; anonymous_id is sent whenever Segment anon id is resolvable.
    isExternal: _isExternal = false,
  }) => {
    const cookieService = new CookieService()
    const getCookie = (cookieName) => cookieService.getCookie(cookieName) ?? undefined
    const getAnalytics = () => (
      typeof window === 'undefined'
        ? undefined
        : /** @type {{ analytics?: { user?: () => { anonymousId?: () => string } } }} */ (window).analytics
    )

    const anonymousId = resolveSegmentAnonymousId({ getCookie, getAnalytics }) ?? null
    const calAnonymousId = getCookie('cal_anonymous_id') || null
    if (calAnonymousId != null) {
      properties.cal_anonymous_id = calAnonymousId
    }

    const amplitudeApiKey = String(Settings.session_replay?.amplitude_api_key ?? '').trim()
    const { deviceId, sessionId } = resolveSegmentAmplitudeIdentity({
      amplitudeApiKey,
      getCookie,
      getAnalytics,
    })

    const data = {
      name,
      version,
      dependencies,
      entities,
      properties,
      anonymous_id: anonymousId,
    }
    if (sessionId != null) {
      data.amplitude_session_id = sessionId
    }
    if (deviceId) {
      data.segment_device_id = deviceId
    }

    const [success, response] = await httpRequest({
      url: '/api/analytics/track',
      method: 'POST',
      data,
    })

    if (!success && !process.env.ENABLE_PLAYWRIGHT && (process.env.NODE_ENV === 'development' || process.env.NODE_ENV === 'review')) {
      alert(`Dispatching ${name} failed.\n\n${response?.payload?.message}`)
    }
  }
}
